import React from 'react';
import PropTypes from 'prop-types';
import Login from './Login';
import Profile from './Profile';
import Modal from './Modal';
import './LoginModal.scss';

export default function LoginModal(props) {
  // 1. Destructure with a default fallback to 'login'
  const { page = 'login', isLoading, isOpen, onRequestClose: closeHandler } = props;
  
  const isCloseable = !isLoading && page !== 'profile';
  const onRequestClose = isCloseable ? closeHandler : () => {};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={`${page}-modal`}
      showCloseButton={isCloseable}
    >
      {/* 2. Now it will safely evaluate to true if page was originally undefined */}
      {page === 'login' ? <Login {...props} /> : <Profile {...props} />}
    </Modal>
  );
}

LoginModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  isLoadingProfiles: PropTypes.bool,
  isManagingProfiles: PropTypes.bool,
  page: PropTypes.oneOf(['login', 'profile']),
  onRequestClose: PropTypes.func.isRequired,
  onSelectProfile: PropTypes.func.isRequired,
  ...Login.propTypes
};

